module.exports = __webpack_public_path__ + "static/media/image-user-2.4d25188e.jpg";